import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSelect from '../../components/CustomSelect/customSelect'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import FormHeader from '../../components/FormHeader/FormHeader'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateOrganization = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  const [formattedOrganizations, setFormattedOrganizations] = useState([])
  const [formattedOrganizationTypes, setFormattedOrganizationTypes] = useState([])
  const [formattedCities, setFormattedCities] = useState([])

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      active: yup
        .boolean()
        .typeError('must be boolean')
        .required(getMessage('isRequired', getMessage('active'))),
      cityStateId: yup
        .number()
        .typeError('must be number')
        .required(getMessage('isRequired', getMessage('cityStateId'))),
      headquarter: yup.boolean().typeError('must be boolean'),
      organizationTypeId: yup
        .number()
        .typeError('must be number')
        .required(getMessage('isRequired', getMessage('organizationTypeId'))),
      organizationName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('organizationName')))
    }),

    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      active: yup.boolean().typeError('must be boolean'),
      cityStateId: yup.number().typeError('must be number'),
      organizationTypeId: yup.number().typeError('must be number'),
      headquarter: yup.boolean().typeError('must be boolean'),
      organizationName: yup.string().typeError('must be string')
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      if (!id) {
        const data = { ...values }
        storeOrganization(data)
      } else {
        const payload = { data: { ...values }, id }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateOrganization(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    if (id) {
      retrieveOrganization(id)
    } else {
      setFormValues({})
    }

    listOrganizations({ ignorePagination: true })
    listOrganizationTypes({ ignorePagination: true })
    listCities({ ignorePagination: true })

    // Use-effect-mount-marker
    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function storeOrganization() {
    try {
      // await request(api.storeOrganization(data))
      notification.success({
        description: getMessage('successStoreOrganization'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveOrganization() {
    try {
      // const response = await request(api.retrieveOrganization(id))
      console.tron.log('response', response)
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateOrganization() {
    try {
      console.tron.log('updateOrganization')
      // const { id, data } = payload
      // await request(api.updateOrganization(id, data))
      notification.success({
        description: getMessage('successUpdateOrganization'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listOrganizations(params) {
    try {
      const response = await request(api.listOrganizations(params))
      console.tron.log('response listOrganizationsRequest', response)
      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.id,
          description: item.organizationName
        })
      })
      setFormattedOrganizations(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listOrganizationTypes(params) {
    try {
      const response = await request(api.listOrganizationTypes(params))
      console.tron.log('response listOrganizationTypesRequest', response)
      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.id,
          description: item.typeName
        })
      })
      setFormattedOrganizationTypes(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listCities(params) {
    try {
      const response = await request(api.listCities(params))
      console.tron.log('response listCitiesRequest', response)
      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.id,
          description: item.cityName
        })
      })
      setFormattedCities(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id !== null ? getMessage('updateOrganization') : getMessage('createOrganization')
  }

  function renderHeader(submitForm) {
    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getTitle()}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            <Button type="primary" onClick={() => submitForm()}>
              {id ? getMessage('update') : getMessage('register')}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({ ...formValues, [field]: value })
            return setFieldValue(field, value)
          }

          return (
            <Form className="organization-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <FormHeader title={getMessage('tab.info')} orientation="left" type="horizontal" />
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="organizationName"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="phoneNumber"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    mask="(11)1111-1111"
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="emailAddress"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="cnpj"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    mask="11.111.111/1111-11"
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="addressDescription"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="addressNumber"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="neighborhood"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="zipCode"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    mask="11111-111"
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="addressComplement"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="headquarter"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="parentOrganizationId"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    values={formattedOrganizations}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="organizationTypeId"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    values={formattedOrganizationTypes}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="cityStateId"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    values={formattedCities}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateOrganization
